module.exports = __webpack_public_path__ + "img/small_logo.07adebae.png";